import format from 'date-fns/format';
import parse from 'date-fns/parse';

const ISO_DATE = 'YYYY-MM-DD';
const ISO_TIME = 'HH:mm';


export function getDateTime(dateStringOrObject, timeString) {
  if (!dateStringOrObject || !timeString) {
    return null;
  }

  const dateString = typeof dateStringOrObject === 'string'
    ? dateStringOrObject
    : format(dateStringOrObject, ISO_DATE);

  return parse(`${dateString}T${timeString} GMT+0200`);
}

export function parseDateTime(dateTimeObject) {
  return {
    date: format(dateTimeObject, ISO_DATE),
    time: format(dateTimeObject, ISO_TIME),
  };
}

export function withTimezone(dateObject, timeZone) {
  const localeDate = new Date(dateObject.toLocaleString('en-US', { timeZone }));
  const diff = dateObject.getTime() - localeDate.getTime();
  return new Date(dateObject.getTime() - diff);
}

export { ISO_DATE, ISO_TIME };
